module.exports = __webpack_public_path__ + "static/media/silkycloud-red-5.c7461743.png";